"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoading = void 0;
var react_1 = __importDefault(require("react"));
var progress_1 = require("@chakra-ui/progress");
var layout_1 = require("@chakra-ui/layout");
var PageLoading = function () {
    return (react_1.default.createElement(layout_1.Box, { position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" },
        react_1.default.createElement(progress_1.CircularProgress, { isIndeterminate: true, color: "#F9B812", mx: "auto", thickness: "4px" })));
};
exports.PageLoading = PageLoading;
